export type SubjectSchema = {
    SubjectName: string,
};

const nameofSubjectSchemaSubjectName = "SubjectName";
const nameofSubjectSchemaCollection = "Subject";

export {
    nameofSubjectSchemaSubjectName,
    nameofSubjectSchemaCollection,
};

export type SubjectView = SubjectSchema & {
    Id: string,
};